module.exports = __webpack_public_path__ + "static/media/brand-refresh-ig-icon.74cbebda.svg";